// extracted by mini-css-extract-plugin
export default {"container":"Container_container__xTud4","small":"Container_small__hDS5J"};